import { Card } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { PlaceTypeIcon } from "@/components/ui/status/place-type-icon";
import { renderPlaceAddress } from "@/features/my/_libs/utils";
import { useCurrentPurchaseIntent } from "@/features/my/checkout/_api/use-current-purchase-intent";
import { useMyPlaceDetail } from "@/features/my/places/_api/use-my-place-detail";
import type { PlaceType } from "@/types/openapi-enum";

export function AddressCard() {
  const { data: purchaseIntent, isLoading: isLoadingPurchaseIntent } =
    useCurrentPurchaseIntent();

  const { data: place, isLoading: isLoadingPlace } = useMyPlaceDetail(
    purchaseIntent?.placeId as string,
  );

  const isLoading = isLoadingPurchaseIntent || isLoadingPlace;

  if (isLoading && !place) {
    return <AddressCardSkeleton />;
  }

  return (
    <Card className="p-4 space-y-2 border border-border-dark-low rounded-2xl shadow-none">
      <div className="flex gap-2 items-center">
        <PlaceTypeIcon
          type={place?.type as PlaceType}
          className="text-text-primary shrink-0 size-6"
        />
        <p className="text-sm leading-5">
          {renderPlaceAddress(place, [
            "address1",
            "address2",
            "city",
            "state",
            "zipcode",
          ])}
        </p>
      </div>
    </Card>
  );
}

export const AddressCardSkeleton = () => {
  return (
    <Card className="p-4 space-y-2 border border-border-dark-low rounded-2xl shadow-none">
      <div className="flex gap-2 items-center">
        <Skeleton className="size-8 rounded-full shrink-0" />
        <Skeleton className="w-full h-6" />
      </div>
    </Card>
  );
};
